<div class="audit-logs-container">
    <div class="page-header">
        <h2>Jurnal Audit</h2>
        <p class="text-muted">Vizualizare istoric operațiuni și modificări în sistem</p>
    </div>

    <!-- Filters Card -->
    <div class="card mb-3">
        <div class="card-header">
            <i class="fa fa-filter"></i> Filtre
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-2">
                    <label class="form-label">Data de la</label>
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="dateFrom">
                </div>
                <div class="col-md-2">
                    <label class="form-label">Data până la</label>
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="dateTo">
                </div>
                <div class="col-md-2">
                    <label class="form-label">Modul</label>
                    <select class="form-control form-control-sm" [(ngModel)]="moduleFilter">
                        <option value="">-- Toate --</option>
                        <option *ngFor="let module of modules" [value]="module.value">{{ module.label }}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Acțiune</label>
                    <select class="form-control form-control-sm" [(ngModel)]="actionFilter">
                        <option value="">-- Toate --</option>
                        <option *ngFor="let action of actions" [value]="action.value">{{ action.label }}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Rezultat</label>
                    <select class="form-control form-control-sm" [(ngModel)]="resultFilter">
                        <option value="">-- Toate --</option>
                        <option *ngFor="let result of results" [value]="result.value">{{ result.label }}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label class="form-label">Utilizator</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="userNameFilter"
                        placeholder="Nume utilizator...">
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-4">
                    <label class="form-label">Căutare generală</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="searchFilter"
                        placeholder="Caută în toate câmpurile...">
                </div>
                <div class="col-md-8 d-flex align-items-end justify-content-end">
                    <button class="btn btn-primary btn-sm me-2" (click)="applyFilters()">
                        <i class="fa fa-search"></i> Aplică Filtre
                    </button>
                    <button class="btn btn-secondary btn-sm me-2" (click)="resetFilters()">
                        <i class="fa fa-refresh"></i> Resetează
                    </button>
                    <button class="btn btn-success btn-sm" (click)="exportCsv()" [disabled]="isExporting">
                        <i class="fa" [ngClass]="{'fa-spinner fa-spin': isExporting, 'fa-download': !isExporting}"></i>
                        Export CSV
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- DataTable -->
    <div class="card">
        <div class="card-body table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                class="table table-striped table-hover table-sm w-100">
            </table>
            <!-- Loading Spinner -->
            <div class="loading-overlay" *ngIf="isLoading">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>

    <!-- Detail Modal -->
    <div class="modal-backdrop" *ngIf="showDetailModal" (click)="closeDetailModal()"></div>
    <div class="modal d-block" *ngIf="showDetailModal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fa fa-info-circle"></i> Detalii Log #{{ selectedLog?.id }}
                    </h5>
                    <button type="button" class="btn-close" (click)="closeDetailModal()"></button>
                </div>
                <div class="modal-body" *ngIf="selectedLog">
                    <div class="row">
                        <div class="col-md-6">
                            <h6>Informații Generale</h6>
                            <table class="table table-sm table-bordered">
                                <tr>
                                    <th width="35%">ID</th>
                                    <td>{{ selectedLog.id }}</td>
                                </tr>
                                <tr>
                                    <th>Data</th>
                                    <td>{{ selectedLog.created_at | date:'dd.MM.yyyy HH:mm:ss' }}</td>
                                </tr>
                                <tr>
                                    <th>Modul</th>
                                    <td>{{ selectedLog.module }}</td>
                                </tr>
                                <tr>
                                    <th>Acțiune</th>
                                    <td>
                                        <span class="badge" [ngClass]="{
                                            'bg-success': selectedLog.action === 'create',
                                            'bg-warning': selectedLog.action === 'update',
                                            'bg-danger': selectedLog.action === 'delete',
                                            'bg-info': selectedLog.action === 'status_change',
                                            'bg-secondary': selectedLog.action !== 'create' && selectedLog.action !== 'update' && selectedLog.action !== 'delete' && selectedLog.action !== 'status_change'
                                        }">{{ selectedLog.action_label }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Rezultat</th>
                                    <td>
                                        <span class="badge"
                                            [ngClass]="selectedLog.result === 'success' ? 'bg-success' : 'bg-danger'">
                                            {{ selectedLog.result_label }}
                                        </span>
                                    </td>
                                </tr>
                                <tr *ngIf="selectedLog.error_message">
                                    <th>Eroare</th>
                                    <td class="text-danger">{{ selectedLog.error_message }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-md-6">
                            <h6>Utilizator</h6>
                            <table class="table table-sm table-bordered">
                                <tr>
                                    <th width="35%">Nume</th>
                                    <td>{{ selectedLog.user_name }}</td>
                                </tr>
                                <tr>
                                    <th>ID User</th>
                                    <td>{{ selectedLog.user_id }}</td>
                                </tr>
                                <tr *ngIf="selectedLog.functie_name">
                                    <th>Funcție</th>
                                    <td><span class="text-info">{{ selectedLog.functie_name }}</span></td>
                                </tr>
                                <tr *ngIf="selectedLog.directie_name">
                                    <th>Direcție</th>
                                    <td>{{ selectedLog.directie_name }}</td>
                                </tr>
                                <tr *ngIf="selectedLog.compartiment_name">
                                    <th>Compartiment</th>
                                    <td>{{ selectedLog.compartiment_name }}</td>
                                </tr>
                                <tr>
                                    <th>IP</th>
                                    <td>{{ selectedLog.ip_address || 'N/A' }}</td>
                                </tr>
                                <tr>
                                    <th>Tip Actor</th>
                                    <td>{{ selectedLog.actor_type_label }}</td>
                                </tr>
                                <tr>
                                    <th>Sursă</th>
                                    <td>{{ selectedLog.source_label }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-12">
                            <h6>Obiect Afectat</h6>
                            <table class="table table-sm table-bordered">
                                <tr>
                                    <th width="17%">Model</th>
                                    <td>{{ selectedLog.short_model_type }} ({{ selectedLog.model_type }})</td>
                                </tr>
                                <tr>
                                    <th>ID Model</th>
                                    <td>{{ selectedLog.model_id }}</td>
                                </tr>
                                <tr>
                                    <th>Nume</th>
                                    <td>{{ selectedLog.model_name || 'N/A' }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="row mt-3" *ngIf="selectedLog.has_diff">
                        <div class="col-md-6">
                            <h6>Valori Vechi</h6>
                            <pre class="bg-light p-2 rounded"
                                style="max-height: 300px; overflow: auto;">{{ formatJson(selectedLog.old_values) }}</pre>
                        </div>
                        <div class="col-md-6">
                            <h6>Valori Noi</h6>
                            <pre class="bg-light p-2 rounded"
                                style="max-height: 300px; overflow: auto;">{{ formatJson(selectedLog.new_values) }}</pre>
                        </div>
                    </div>

                    <div class="row mt-3" *ngIf="selectedLog.user_agent">
                        <div class="col-12">
                            <h6>User Agent</h6>
                            <small class="text-muted">{{ selectedLog.user_agent }}</small>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeDetailModal()">Închide</button>
                </div>
            </div>
        </div>
    </div>
</div>